import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';

const FADE_HEIGHT = 32;

export default function ScrollFadeBox({ children, sx, scrollSx }) {
  const scrollRef = useRef(null);
  const contentRef = useRef(null);
  const [showTopFade, setShowTopFade] = useState(false);
  const [showBottomFade, setShowBottomFade] = useState(false);

  const checkScrollPosition = () => {
    const el = scrollRef.current;
    if (!el) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    setShowTopFade(scrollTop > 1);
    setShowBottomFade(scrollTop < scrollHeight - clientHeight - 1);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    checkScrollPosition();
    el.addEventListener('scroll', checkScrollPosition);

    const observer = new ResizeObserver(checkScrollPosition);
    if (contentRef.current) observer.observe(contentRef.current);

    return () => {
      el.removeEventListener('scroll', checkScrollPosition);
      observer.disconnect();
    };
  }, []);

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <Box ref={scrollRef} className="custom-scrollbar" sx={{ position: 'absolute', inset: 0, overflowY: 'auto', ...scrollSx }}>
        <Box ref={contentRef}>{children}</Box>
      </Box>

      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: FADE_HEIGHT,
          background: 'linear-gradient(to bottom, #000 0%, transparent 100%)',
          pointerEvents: 'none',
          opacity: showTopFade ? 1 : 0,
          transition: 'opacity 0.25s ease-in-out',
        }}
      />
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: FADE_HEIGHT,
          background: 'linear-gradient(to top, #000 0%, transparent 100%)',
          pointerEvents: 'none',
          opacity: showBottomFade ? 1 : 0,
          transition: 'opacity 0.25s ease-in-out',
        }}
      />
    </Box>
  );
}
